// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"953b14c3","156":"d7bf37cb","431":"e7618b5c","489":"d84065ae","608":"58ab4113","787":"4e24d15b","880":"a1344650"}[chunkId] + ".chunk.js";
};